import React from "react";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";

export const CustomTextField = styled(TextField)({
  "& .MuiInputBase-root": {
    borderRadius: 8,
    backgroundColor: "#ffffff",
    "& ::placeholder": {
      fontSize: 14,
      color: "#718291",
      fontWeight: 400,
      opacity: 1,
    },
    "& fieldset": {
      borderColor: "#DEE7EE",
    },
    "&:hover fieldset": {
      borderColor: "#DEE7EE",
    },
    "&.Mui-error fieldset": {
      borderColor: "#f50057",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#7034e0",
    },
  },
});

const SimpleTextInput = ({
  inputRef,
  placeholder,
  size = "small",
  variant = "outlined",
  fullWidth = true,
  ...other
}) => {
  return (
    <CustomTextField
      inputRef={inputRef}
      placeholder={placeholder}
      size={size}
      fullWidth={fullWidth}
      variant={variant}
      {...other}
    />
  );
};

export default SimpleTextInput;
